// extracted by mini-css-extract-plugin
module.exports = {"records":"index_records_11OWt","table-wrapper":"index_table-wrapper_2NoeQ","empty":"index_empty_3Jmf4","address":"index_address_3nKXD"};